import { render, staticRenderFns } from "./GridSection.vue?vue&type=template&id=2c9c6fda&scoped=true"
import script from "./GridSection.vue?vue&type=script&lang=js"
export * from "./GridSection.vue?vue&type=script&lang=js"
import style0 from "./GridSection.vue?vue&type=style&index=0&id=2c9c6fda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9c6fda",
  null
  
)

export default component.exports